module.exports = __webpack_public_path__ + "803cfcbda5a1f206e8de31262d791038.svg";